import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class VersionesServices {
    private apiUrl = 'https://api.bancodelagua.com/channel'; // URL oficial
    private peticionDatosAPI = '?pass=c65a0da4b357b83677f25803684f5a90';
    public currentVersion = '18.1.0';
    constructor(private http: HttpClient) { }

    /**
     * Obtiene la versión oficial desde el servidor.
     */
    getOfficialVersion(): Promise<any> {
        console.log('Solicitando versión oficial desde el servidor:', this.apiUrl);
        const apiPath = `${this.apiUrl}/redatwater/versiones${this.peticionDatosAPI}`;

        return new Promise((resolve, reject) => {
            this.http.get(apiPath).subscribe(
                (response: any) => {
                    console.log('Respuesta del servidor ->', response);
                    resolve(response);
                },
                (error) => {
                    console.error('Error en la petición:', error);
                    reject(error);
                }
            );
        });
    }

    /**
     * Compara las versiones y retorna si hay actualización disponible.
     */
    async checkForUpdate(): Promise<{
        isUpdateAvailable: boolean;
        currentVersion: string;
        officialVersion: string;
        mensaje: string;
    }> {
        try {
           
            // Obtener la versión oficial desde el servidor
            const response: any = await this.getOfficialVersion();

            if (response.estado && response.respuesta?.channel?.version_app) {
                const officialVersion = response.respuesta.channel.version_app;
                const isUpdateAvailable = this.compareVersions(officialVersion, this.currentVersion);
                const currentVersion = this.currentVersion;
                return {
                    isUpdateAvailable,
                    currentVersion,
                    officialVersion,
                    mensaje: response.messages?.[0]?.msg || 'Versión obtenida correctamente.',
                };
            }

            throw new Error('Respuesta inválida del servidor o estado falso.');
        } catch (error) {
            console.error('Error al verificar actualizaciones:', error);
            throw error;
        }
    }

    /**
     * Compara dos versiones (semánticas) en formato X.Y.Z.
     */
    private compareVersions(official: string, current: string): boolean {
        const parseVersion = (version: string) => version.split('.').map((num) => parseInt(num, 10));
        const [major1, minor1, patch1] = parseVersion(official);
        const [major2, minor2, patch2] = parseVersion(current);

        if (major1 > major2) return true;
        if (major1 === major2 && minor1 > minor2) return true;
        if (major1 === major2 && minor1 === minor2 && patch1 > patch2) return true;

        return false;
    }
}
